import { render, staticRenderFns } from "./deleteDialog.vue?vue&type=template&id=0df5ba1c&scoped=true&"
import script from "./deleteDialog.vue?vue&type=script&lang=js&"
export * from "./deleteDialog.vue?vue&type=script&lang=js&"
import style0 from "./deleteDialog.vue?vue&type=style&index=0&id=0df5ba1c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0df5ba1c",
  null
  
)

export default component.exports